import { IconButton, Id, isSuccess, usePaginatedList, useToasts } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { contactService } from "../shared/api/contactService";

interface props {
	isArchived: boolean;
	filterId: Id | null;
	viewId: Id | undefined;
}

export const ContactExportButton: FC<props> = ({ isArchived, filterId, viewId }) => {
	const { t } = useTranslation();
	const { showToast } = useToasts();
	const { searchParams, sort } = usePaginatedList();

	const createExport = useCallback(async () => {
		const response = await contactService.postExport(isArchived, viewId, filterId, searchParams?.search, sort);
		if (isSuccess(response)) {
			showToast({
				body: t("An export is being created, please wait."),
				title: t("Export"),
				type: "success",
			});
		}
	}, [isArchived, viewId, filterId, searchParams, sort, showToast, t]);

	return (
		<IconButton type="button" size="small" onClick={() => createExport()} title={t("Download")} icon="file_download" />
	);
};
